// Approved Stitch "Digital Vernacular" direction.
// Kept independent from the legacy theme so new surfaces can converge safely.
export const lifeTaggerDesign = {
  // Stitch's approved organizational-dashboard palette. Kept explicit so
  // consumer/contextual surfaces can retain their own approved variants.
  dashboard: {
    primary: '#F58A33',
    secondary: '#0F1419',
    tertiary: '#1B3022',
    neutral: '#F9F8F6',
  },
  color: {
    ink: '#1A1C1B',
    action: '#E96842',
    actionDark: '#B84427',
    warmInk: '#1F1B1A',
    canvas: '#F4F0E8',
    paper: '#FFFCF7',
    muted: '#706C65',
    border: '#D8D1C5',
    moss: '#294438',
    sage: '#D8E2D4',
  },
  type: {
    headline: '"Cormorant Garamond", Georgia, serif',
    brand: '"Instrument Serif", Georgia, serif',
    body: 'Geist, Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  },
  radius: {
    card: 28,
    control: 12,
  },
};
